import React from 'react'
import PropTypes from 'prop-types'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { materialDark } from 'react-syntax-highlighter/dist/esm/styles/prism'

export const InlineCode = ({ value }) => (
  <code className="language-text">{value}</code>
)

InlineCode.propTypes = {
  value: PropTypes.string.isRequired,
}

export const CodeBlock = ({ language, value }) => (
  <SyntaxHighlighter language={language} style={materialDark}>
    {value}
  </SyntaxHighlighter>
)

CodeBlock.propTypes = {
  value: PropTypes.string.isRequired,
  language: PropTypes.string,
}

CodeBlock.defaultProps = {
  language: null,
}
